import React, { createContext, useState, useEffect } from "react";
import { db } from "./firebase";
import { doc, getDoc, setDoc, onSnapshot } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const FirebaseContext = createContext();

const FirebaseProvider = ({ children }) => {
    const [loading, setLoading] = useState(true); // State to manage loading
    const [userAuth, setUserAuth] = useState(null); // State to hold the authenticated user
    const [userData, setUserData] = useState(null); // State to hold user-specific data

    // TO DO: TEMPORARY
    const [characterJSON, setCharacterJSON] = useState({});
    
    useEffect(() => {
        const auth = getAuth();
      
        // Listen for authentication state changes
        const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
            let unsubscribeData; // Declare unsubscribeData to hold the Firestore listener cleanup function
      
            if (user) {
                setUserAuth(user);
                const userDocRef = doc(db, "users", user.uid);
      
                // Fetch user-specific data
                const userDocSnap = await getDoc(userDocRef);

                if (userDocSnap.exists()) {
                    setUserData(userDocSnap.data());
                } else {
                    // Create a user document if it doesn't exist
                    console.log("First time sign-in: New user document created.");
                    await setDoc(userDocRef, {
                        uid: user.uid,
                        email: user.email,
                        displayName: user.displayName,
                        photoURL: user.photoURL,
                        timestamp: {
                            createdAt: new Date(),
                            lastUpdatedAt: new Date(),
                        },
                    });
                    // TO DO: Instead of doing this, re-fetch the data directly from Firebase to ensure it's in sync
                    setUserData({
                        uid: user.uid,
                        email: user.email,
                        displayName: user.displayName,
                    });
            }
      
                // If you have a Firestore listener, you might want to set it up here
                // Example: 
                // unsubscribeData = onSnapshot(userDocRef, (doc) => {
                //   setUserData(doc.data());
                // });
        
                // Stop loading once data is fetched
                setLoading(false);
            } else {
                // If user logs out, clear the data
                setUserAuth(null);
                setUserData(null);
                setLoading(false);
            }
      
            // Cleanup the Firestore listener when the user changes or logs out
            return () => {
                if (unsubscribeData) unsubscribeData();
            };
        });
      
        // Cleanup the authentication state listener when the component unmounts
        return () => unsubscribeAuth();
    }, []);
      

    if (loading) {
        return <div>Loading...</div>; // Render a loading state while data is being fetched
    } else {
        return (
            <FirebaseContext.Provider value={{ loading, userData, characterJSON, setCharacterJSON }}>
                {children}
            </FirebaseContext.Provider>
        );
    }
}

export { FirebaseContext, FirebaseProvider };
